@let menu = menu$ | async;
@let firstLink = menu?.[0]?.children?.[0]?.url || '';

<!-- DESKTOP -->
<ng-container *ngIf="mini; else mobile">
  <ng-container *ngTemplateOutlet="nav"></ng-container>
  <span fxFlex></span>
  <footer>
    <ng-template [ngTemplateOutlet]="user"></ng-template>
    <a
      mat-icon-button
      [@trigger]="expanded ? '1' : '0'"
      (click)="sidenavToggle.emit()"
      [matTooltip]="
        (expanded ? 'FTR_MENU_COLLAPSE' : 'FTR_MENU_EXPAND') | translate
      "
      matTooltipPosition="after">
      <mat-icon svgIcon="right-arrow"></mat-icon>
    </a>
  </footer>
</ng-container>

<!-- Mobile sidenav -->
<ng-template #mobile>
  <ng-container *ngTemplateOutlet="nav"></ng-container>
  <span fxFlex></span>
  <ng-template [ngTemplateOutlet]="user"></ng-template>
</ng-template>

<!-- nav reference -->
<ng-template #nav>
  <mat-toolbar class="mat-toolbar--small">
    <div fxLayout="column" fxLayoutAlign="space-around center">
      <a
        [routerLink]="'/' + firstLink"
        (click)="sidenav.opened && sidenav.close()">
        <mat-icon class="sidenav-mini__logo" svgIcon="main-logo"></mat-icon>
      </a>
    </div>
    <h1 *ngIf="!mini || expanded" class="sidenav-mini__mobile-title">
      {{ (mobileTitle | async | translate)?.toLowerCase() }}
    </h1>
  </mat-toolbar>
  <mat-nav-list class="nav">
    @for (menuEntry of menu; track menuEntry.title; let i = $index) {
      <p class="nav__header mat-subtitle-2" *ngIf="!mini || expanded">
        {{ menuEntry.title | translate }}
      </p>
      @for (subMenu of menuEntry.children; track subMenu.title) {
        <a
          mat-list-item
          [ngClass]="!mini || expanded ? 'nav__link-opened' : 'nav__link'"
          routerLink="/{{ subMenu.url }}"
          routerLinkActive="active-list-item"
          [routerLinkActiveOptions]="!subMenu.url ? { exact: true } : $any({})"
          [matTooltipDisabled]="!mini || expanded"
          matTooltip="{{ menuEntry.title | translate }}: {{
            subMenu.title | translate
          }}"
          matTooltipPosition="right"
          matTooltipShowDelay="100"
          style="width: inherit !important">
          <mat-icon
            matListItemIcon
            *ngIf="subMenu.icon.ent === 'google'; else customIcon"
            [class.nav__icon-flip]="subMenu.icon.flip">
            {{ subMenu.icon.name }}
          </mat-icon>

          <ng-template #customIcon>
            <mat-icon
              matListItemIcon
              [svgIcon]="subMenu.icon.name"
              [class.nav__icon-flip]="subMenu.icon.flip"></mat-icon>
          </ng-template>

          <p
            class="nav__link__title"
            matListItemTitle
            [class.hidden]="mini && !expanded">
            {{ subMenu.title | translate }}
          </p>
        </a>
      }
    }
  </mat-nav-list>
</ng-template>

<ng-template #user>
  <qt-avatar-menu
    *ngIf="!media.isActive('gt-xs')"
    [sidenav]="sidenav"></qt-avatar-menu>
</ng-template>
